/**
 * Remonte le DOM depuis `element` jusqu'au premier ancêtre réellement
 * scrollable verticalement (`overflow-y` auto/scroll et hauteur débordante),
 * ou `null` si aucun (le scroll retombe alors sur la fenêtre).
 */
export function getScrollParent(
  element: HTMLElement | null
): HTMLElement | null {
  let current = element?.parentElement ?? null;
  while (current) {
    const { overflowY } = window.getComputedStyle(current);
    const isScrollable = overflowY === "auto" || overflowY === "scroll";
    if (isScrollable && current.scrollHeight > current.clientHeight) {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}
